import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "datafilter",
})
export class DataFilterPipe implements PipeTransform {
  transform(items: Array<any>, callback: any): any {
    return items.filter(callback);
  }
}



// WEBPACK FOOTER //
// ./src/pipes/output-formatters/data-filter.pipe.ts